<template>
  <pt-detection-corpus-structure-list class="pt-detection-corpus-structure-list__withData"></pt-detection-corpus-structure-list>
</template>

<script>
import PtDetectionCorpusStructureList from './index'
export default {
  name: 'pt-detection-corpus-structure-list__withData',
  components: {
    'pt-detection-corpus-structure-list': PtDetectionCorpusStructureList
  }
}
</script>
